import { createContext } from 'react';

import { SalesOrderHeader } from '@totem/components/salesOrders/details/types';

interface Context {
  loading: boolean;
  header: SalesOrderHeader | null;
}

const defaultContext: Context = {
  loading: false,
  header: null,
};

const SalesOrderDetailContext = createContext<Context>(defaultContext);

export default SalesOrderDetailContext;
